

export const appointmentAdapter = (data: any) => Object.keys(data).reduce((res: object, key: string) => {
    if(data[key].value) return { ...res, [key]: data[key].value }
    return { ...res, [key]: Array.isArray(data[key]) ? data[key].map(({ value }: { value: string }) => value)?.join(', ') : data[key] }
}, {})